import React from "react"
import { WishlistAvailabilityItem } from "../../../../api/backend/backend-api"
import { CustomBox } from "../../../../ui/spacings"
import WishlistItem from "../WishlistItem"

interface Props {
  items: WishlistAvailabilityItem[]
  onItemAddedToBasket?: (item: WishlistAvailabilityItem) => void
}

const WishlistItems = ({ items, onItemAddedToBasket }: Props) => {
  return (
    <>
      {items.map((x, index) => (
        <CustomBox key={index} my={2}>
          <WishlistItem
            item={x}
            onAddedToBasket={() => onItemAddedToBasket?.(x)}
          />
        </CustomBox>
      ))}
    </>
  )
}

export default WishlistItems
